document.addEventListener('DOMContentLoaded', function() {

  let collection_tabs = document.querySelectorAll('.navigation-tabs p');
  let collections = document.querySelectorAll('.collection-list__wrapper .collection-list-card');

  collection_tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        let datatab = tab.getAttribute("data-tab");

        removeClassArray(collection_tabs, 'active');
        tab.classList.add('active');

        if(datatab == 'all'){
          collections.forEach( collection => {
            collection.style.display = 'block';
          })
        } else {
          collections.forEach( collection => {
            let collectionDataTab = collection.getAttribute('data-tab');
  
            if(collectionDataTab != datatab) {
              collection.style.display = 'none';
            } else {
              collection.style.display = 'block';
            }
          })
        }
      })
  });


  function removeClassArray(array, className) {
    array.forEach(element => {
      element.classList.remove(`${className}`);
    });
  }

});